<template>
  <b-container fluid>
    <b-breadcrumb :items="breadcrumbs"/>
    <b-row>
      <b-col md="6">
        <b-card title="Change My Password">
          <b-form v-on:submit.prevent.stop="submit">
            <b-form-group id="old_password_label" label="Current Password" label-for="old_password">
              <b-input id="old_password" type="password" v-model="oldPassword" required></b-input>
            </b-form-group>
            <b-form-group id="new_password_label" label="New Password" label-for="new_password">
              <b-input id="new_password" type="password" v-model="newPassword" required></b-input>
            </b-form-group>
            <b-alert variant="warning" :show="showPasswordWarning">Password is not secure. {{passwordWarning}}</b-alert>
            <b-form-group id="confirm_new_password_label" label="Confirm New Password" label-for="confirm_new_password">
              <b-input id="confirm_new_password" type="password" v-model="confirmNewPassword" required></b-input>
            </b-form-group>
            <b-alert variant="danger" :show="errorMessage != null">{{errorMessage}}</b-alert>
            <div class="text-right">
              <b-button to="/settings">Cancel</b-button>
              <b-button type="submit" variant="primary">Save</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-container>

</template>

<script>
import API from '@/lib/api'
import zxcvbn from 'zxcvbn'

export default {
  name: 'ChangePassword',
  components: {
  },
  data () {
    return {
      breadcrumbs: [{text: 'My Vos Voco', to: '/'}, {text: 'Settings', to: '/settings'}, {text: 'Change My Password', to: '/settings/password', active: true}],
      oldPassword: null,
      newPassword: null,
      confirmNewPassword: null,
      errorMessage: null,
      showPasswordWarning: false,
      passwordWarning: null
    }
  },
  watch: {
    'newPassword': function () {
      const result = zxcvbn(this.newPassword)
      this.showPasswordWarning = (result.score < 3)
      if (result.feedback != null && result.feedback.warning != null && result.feedback.warning !== '') {
        this.passwordWarning = result.feedback.warning
      } else {
        this.passwordWarning = result.feedback.suggestions.join('. ')
      }
    }
  },
  methods: {
    submit () {
      const params = {
        old_password: this.oldPassword,
        new_password: this.newPassword,
        confirm_new_password: this.confirmNewPassword
      }
      API.post('account/password', params, this.$store.getters.authHeaders).then((result) => {
        this.$root.showToast('Changes Saved')
        this.$router.push('/settings')
      }).catch((error) => {
        if (error.response && error.response.status === 422) {
          this.errorMessage = error.response.data.message
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/ChangePassword.vue